import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { errorToast, successToast } from 'helpers';
import i18n from 'locales/i18n';
import { RankingMasterInformation, RequestParams, ShopSettingTypes } from 'models';

interface InitialState {
  shopSetting: {
    data: ShopSettingTypes;
    shopId: null;
  };
  shopLogSetting: Array<any>;
  shopLogSettingLoading: boolean | undefined;
  permissionStaff: any;
  permissionStaffLoading: boolean;
  updatePermissionStaffLoading: boolean;
  permissionByUser: Array<RankingMasterInformation>;
  permissionByUserLoading: boolean;
}
const saveShopSetting = typeof window !== 'undefined' ? localStorage.getItem('shopSetting') : null;
const initialState: InitialState = {
  shopSetting: {
    data: saveShopSetting ? JSON.parse(saveShopSetting) : ({} as ShopSettingTypes),
    shopId: null,
  },
  shopLogSetting: [],
  shopLogSettingLoading: undefined,
  permissionStaff: [],
  permissionStaffLoading: true,
  permissionByUser: [],
  permissionByUserLoading: true,
  updatePermissionStaffLoading: false,
};

const shopSettingSlice = createSlice({
  name: 'shopSetting',
  initialState,
  reducers: {
    getShopSetting(state, action: PayloadAction<{ token: string; params: { shop_id: number } }>) {},

    getShopSettingSuccess(state, action: PayloadAction<any>) {
      state.shopSetting = action.payload;
      localStorage.setItem('shopSetting', JSON.stringify(action.payload.data));
    },
    updateShopSettings(state, action: PayloadAction<{ token: string; data: any }>) {},

    updateShopSettingsSuccess(state: any, action: PayloadAction<any>) {
      state.shopSettings = action.payload;
      localStorage.setItem('shopSetting', JSON.stringify(action.payload.data));
    },
    getShopLogSetting(
      state,
      action: PayloadAction<{
        token: string;
        params: {
          shop_ids?: Array<number>;
          shop_id?: number;
          type_get: string;
          type: Array<string | number>;
          date: string;
        };
      }>
    ) {
      state.shopLogSettingLoading = true;
    },
    getShopLogSettingSuccess(state, action: PayloadAction<any>) {
      state.shopLogSetting = action.payload;
      state.shopLogSettingLoading = false;
    },
    updatePermissionStaff(
      state,
      action: PayloadAction<{
        token: string;
        dataBody: {
          permission: Array<{
            name: string;
            active: number;
            app_name: Array<number>;
            shop_id: number;
            id?: number;
          }>;
        };
      }>
    ) {
      state.permissionStaffLoading = true;
      state.updatePermissionStaffLoading = true;
    },
    updatePermissionStaffSuccess(state, action: PayloadAction<Array<RankingMasterInformation>>) {
      successToast(i18n.t('UPDATED_SUCCESSFULLY'));
      state.permissionStaff = action.payload;
      state.permissionStaffLoading = false;
      state.updatePermissionStaffLoading = false;
      if (!Array.isArray(action.payload)) return;
      state.permissionByUser = state.permissionByUser.map((permissionUser) => {
        const foundItem = action.payload.find((item) => item.shop_id === permissionUser.shop_id);
        if (!foundItem) return permissionUser;
        return {
          ...permissionUser,
          active: foundItem.active,
        };
      });
    },
    updatePermissionStaffFailed(state) {
      errorToast(i18n.t('UPDATED_FAILED'));
      state.permissionStaff = initialState.permissionStaff;
      state.permissionStaffLoading = false;
      state.updatePermissionStaffLoading = false;
    },
    getPermissionByUser(state, action: PayloadAction<{ token: string }>) {
      state.permissionByUserLoading = true;
    },
    getPermissionByUserSuccess(state, action: PayloadAction<Array<RankingMasterInformation>>) {
      state.permissionByUserLoading = false;
      state.permissionByUser = action.payload;
    },
    getPermissionByUserFailed(state) {
      state.permissionByUserLoading = false;
    },
    resetPermissionByUser(state) {
      state.permissionByUser = initialState.permissionByUser;
    },
  },
});

// Actions
export const shopSettingActions = shopSettingSlice.actions;

// Selectors
export const shopSettingSelect = (state: any) => state.shopSetting;
// Reducer
const shopSettingReducer = shopSettingSlice.reducer;
export default shopSettingReducer;
